export default "__VITE_ASSET__DtSWkL5Q__"